export const FIELDS = {
  EMAIL: 'email',
  PASSWORD: 'password',
  ORGANIZATION: 'organization',
};



// WEBPACK FOOTER //
// ./src/views/Auth/SignUpForm/constants.js